import "./ConsolidatedHeader.css";
import HomeLogo from "../../assets/Navbarhome.svg";
import { useState } from "react";
import React from "react";
import { Divider } from "rsuite";
import useWdEdgeConsolidatedSource, {
	wdEdgeConsolidatedSessionKeys,
} from "../../hooks/useWdEdgeConsolidatedSource";
import { MainNavbarMenu } from "../../utils/consolidatedConstants";
import UpArrow from "../../assets/expand-menu.svg";

const ConsolidatedHeader = () => {
	const [isMenuOpen, setisMenuOpen] = useState<number | null>(null);
	const [issubMenuOpen, setissubMenuOpen] = useState<number | null>(null);
	const [activeMenu, setActiveMenu] = useState<number | null>(1);
	const { sourceRedirectUrl } = useWdEdgeConsolidatedSource();
	const toggleisMenuOpen = (id: number) => {
		setissubMenuOpen(null);
		if (id == isMenuOpen) {
			setisMenuOpen(null);
		} else {
			setisMenuOpen(id);
		}
	};

	const toggleissubMenuOpen = (id: number) => {
		if (id == issubMenuOpen) {
			setissubMenuOpen(null);
		} else {
			setissubMenuOpen(id);
		}
	};

	const closeSubMenuAndMenu = () => {
		setissubMenuOpen(null);
		setisMenuOpen(null)
	}
	const handleItemClick = (url: string) => {
		const urlObj = new URL(url);
		const queryParams = urlObj.searchParams;
		queryParams.set("source", "wdedgeconsolidated");
		queryParams.set("source-redirect-url", sourceRedirectUrl);
		urlObj.search = queryParams.toString();
		sessionStorage.removeItem(wdEdgeConsolidatedSessionKeys.redirectUrl);
		sessionStorage.removeItem(
			wdEdgeConsolidatedSessionKeys.isSourceWdEdgeConsolidated
		);
		closeSubMenuAndMenu()
		window.location.href = urlObj.toString();
	};

	const handleRoute = (route: string) => {
		sessionStorage.removeItem(wdEdgeConsolidatedSessionKeys.redirectUrl);
		sessionStorage.removeItem(
			wdEdgeConsolidatedSessionKeys.isSourceWdEdgeConsolidated
		);
		closeSubMenuAndMenu()
		window.location.href = `${sourceRedirectUrl}${route}`;
	};

	return (
		<div className="menu-container">
			{MainNavbarMenu.map((menu, index) => (
				<React.Fragment key={menu.id}>
					{index !== 0 && <Divider className="divider" />}

					<div
						className={`menu ${isMenuOpen === menu.id ? "" : ""} ${4 === menu.id ? "active" : ""
							}`}
						key={menu.id}
					>
						<div
							className="menu-title"
							onClick={() => {
								if (menu.route) handleRoute(menu.route);
								else toggleisMenuOpen(menu.id);
							}}
						>
							<p>
								{menu.title == "Home" ? (
									<img
										src={HomeLogo}
										alt="Home icon"
										width={14}
										height={14}
										className="home-icon"
									/>
								) : (
									menu.title
								)}
							</p>
							{menu.subMenu && (
								<img
									src={UpArrow}
									alt="accordion icon"
									width={14}
									height={14}
									className={`accordion-icon ${isMenuOpen === menu.id
										? ""
										: "rotate-accordion-icon"
										}`}
									data-testid="accordion-icon"
								/>
							)}
						</div>
						{isMenuOpen === menu.id && (
							<div className="submenu-container">
								<ul>
									{menu.subMenu?.map((subMenu) => (
										<li
											key={subMenu.id}
											className="submenu"
											onClick={() => {
												if (subMenu?.url) {
													handleItemClick(
														subMenu.url
													)
												}
												else
													toggleissubMenuOpen(
														subMenu.id
													);
											}}
										>
											<span>{subMenu.title}</span>
											{subMenu?.items && (
												<img
													src={UpArrow}
													alt="accordion icon"
													width={14}
													height={14}
													className="accordion-submenu-icon"
													data-testid="accordion-icon"
												/>
											)}
											{issubMenuOpen === subMenu.id && (
												<div className="items-container">
													<ul>
														{subMenu?.items?.map(
															(item) => (
																<li
																	key={
																		item.id
																	}
																	className="item"
																	onClick={() =>
																		handleItemClick(
																			item.url
																		)
																	}
																>
																	<span>
																		{
																			item.title
																		}
																	</span>
																</li>
															)
														)}
													</ul>
												</div>
											)}
										</li>
									))}
								</ul>
							</div>
						)}
					</div>
				</React.Fragment>
			))}
		</div>
	);
};

export default ConsolidatedHeader;
